import React, { useEffect, useRef, useState } from "react";
import "./style.scss";
import {
  getPredefineOptionsList,
  openLoader,
  closeLoader,
} from "../../../AdminDashboard/AdminMentorAction/dependencies/action";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import { Modal } from "react-bootstrap";
import { Paper, Typography } from "@material-ui/core";
import useStyles from "./style";
import "@fontsource/montserrat";
import MessagesTable from "./messageTable";
import { VIEW_BROADCAST_MESSAGES } from "../../../../../common/constants/ApplicationUrl";
import api from "../../../../../common/dependencies/utils/Api";

import axios from "axios";
import Pagination from "react-js-pagination";

const CustomModal = (props) => {
  const classes = useStyles();
  const { modalOpen } = props;
  const value = JSON.parse(localStorage.getItem("SavedLoggedInData"));

  const [data, setData] = useState();
  const [paginationData, setPaginationData] = useState();
  const [currentPage, setCurrentPage] = useState(1);
  useEffect(() => {
    // axios({
    //   url: VIEW_BROADCAST_MESSAGES,
    //   method: "post",
    //   data: {
    //     senderId: value?.id,
    //     pageFilter: {
    //       currentPage: currentPage - 1,
    //       includeCount: true,
    //       pageSize: 10,
    //       sortField: "timestamp",
    //       sortOrder: "DESC",
    //     },
    //   },
    // })
    api
      .POST(VIEW_BROADCAST_MESSAGES, {
        senderId: value?.id,
        pageFilter: {
          currentPage: currentPage - 1,
          includeCount: true,
          pageSize: 10,
          sortField: "timestamp",
          sortOrder: "DESC",
        },
      })
      .then((res) => {
        setData(res.data?.data);
        setPaginationData(res.data?.paginate);
      })
      .catch((err) => {});
  }, [modalOpen]);

  const handleClose = () => {
    props.setModalOpen(false);
  };

  const handleChangeOfPage = (pageNumber) => {
    setCurrentPage(pageNumber);
  };

  return (
    <Modal
      size="lg"
      show={props.modalOpen}
      onHide={() => props.setModalOpen(false)}
      aria-labelledby="example-modal-sizes-title-lg"
      style={{ borderRadius: "7px" }}
    >
      <Modal.Header className="d-flex ">
        <Modal.Title className="modalHeading d-flex justify-content-center">
          VIEW BROADCAST MESSAGES
        </Modal.Title>
        <div className="newuserTooltip">
          <button
            type="button"
            className="btn-close"
            aria-label="Close"
            onClick={handleClose}
          />
          <span
            className="tooltiptext  close-window"
            style={{ left: "-110px", top: "2px", width: "118px" }}
          >
            Close Window
          </span>
        </div>
      </Modal.Header>
      <Modal.Body>
        <Paper elevation={0} className={classes.listContainer}>
          <Typography
            style={{
              textAlign: "right",
              fontFamily: "Montserrat",
              color: "rgba(0,0,0,0.5)",
              fontWeight: "bold",
            }}
          >
            {`Total Items Found:`}
            {paginationData !== undefined &&
              ` ${
                paginationData ? parseInt(paginationData.totalElements) : ""
              } < ${paginationData?.currentPage} of ${
                paginationData?.numPages
              } >`}
          </Typography>
          <MessagesTable data={data} />
          <div className="pagination-box">
            <Pagination
              activePage={currentPage}
              itemsCountPerPage={paginationData?.pageSize}
              totalItemsCount={paginationData?.totalElements}
              pageRangeDisplayed={5}
              onChange={handleChangeOfPage.bind(this)}
            />
          </div>
        </Paper>
      </Modal.Body>
    </Modal>
  );
};
const mapStateToProps = (state) => {
  return {
    getPredefineOptions: state.AdminMentorReducer.getPredefineOptionsList.list,
  };
};
export default connect(mapStateToProps, {
  getPredefineOptionsList,
  openLoader,
  closeLoader,
})(withRouter(CustomModal));
